// extracted by mini-css-extract-plugin
module.exports = {"container":"i_Ck","special":"i_Cl","size-xl":"i_Cm","size-l":"i_Cn","size-m":"i_Co","size-s":"i_Cp","size-xs":"i_Cq","size-2xs":"i_Cr"};